var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1412",
    "data-name": "Group 1412",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.605,
    height: 20.63,
    viewBox: "0 0 20.605 20.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 20.605,
    height: 20.63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1411",
    "data-name": "Group 1411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M37.227.026a3.033,3.033,0,0,1,3.39,3.825L35.41,17.638c-1.344,2.378-4.268,2.048-5.43-.338-.555-1.14-1.016-2.378-1.536-3.539l.042-.1,4.788-4.784a1.014,1.014,0,0,0-1.445-1.4l-4.763,4.759-.143.046-3.735-1.635a2.99,2.99,0,0,1-.1-5.334L36.549.218a3.719,3.719,0,0,1,.678-.192",
    transform: "translate(-20.115 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M31.3,223.571a1.044,1.044,0,0,1,1.155,1.542l-2.6,2.624a1.05,1.05,0,0,1-1.487-1.439,27.636,27.636,0,0,1,2.5-2.522,1.054,1.054,0,0,1,.423-.2",
    transform: "translate(-26.365 -209.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M2.032,176.508a1.053,1.053,0,0,1,1.083,1.471,7.071,7.071,0,0,1-1.492,1.553,1.051,1.051,0,0,1-1.538-1.3,10.334,10.334,0,0,1,1.4-1.5,1.347,1.347,0,0,1,.545-.23",
    transform: "translate(0 -165.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M95.731,270.248a1.06,1.06,0,0,1,1.118,1.5,12.274,12.274,0,0,1-1.564,1.578,1.059,1.059,0,0,1-1.308-1.6,11.821,11.821,0,0,1,1.49-1.41,1.178,1.178,0,0,1,.264-.075",
    transform: "translate(-87.706 -252.824)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.97fd481998865688b02d73a64a4e3e06.svg";
export { ForwardRef as ReactComponent };